export default "__VITE_ASSET__DFzswo9Q__"